import { Text, View } from "./Base";

import { heatmapMapping } from "../utils/map";
import { makeStyles } from "@mui/styles";
import { palette } from "../theme/palette";

const useStyles = makeStyles({
  legend: {
    bottom: "10px",
    position: "absolute",
    zIndex: "100",
    display: "flex",
  },
  itemContainer: {
    width: "30px",
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  box: {
    display: "inline-block",
    height: "13px",
    width: "13px",
    border: `1px solid ${palette.typography.black.inactive}`,
  },
  text: {
    color: palette.typography.white.high,
    fontSize: "12px",
    paddingTop: "5px",
  },
});

export const HeatmapLegend = () => {
  const styles = useStyles();

  return (
    <View className={styles.legend}>
      {Object.keys(heatmapMapping).map((value, index) => (
        <View key={index} className={styles.itemContainer}>
          <View
            className={styles.box}
            style={{ backgroundColor: heatmapMapping[value] }}
          ></View>
          <Text className={styles.text}>{value}</Text>
        </View>
      ))}
    </View>
  );
};
